// src/mixins/tableFiltersMixin.js
import { normalize, isEmpty, uniqueOptions, makeRowFilter } from '@/utils/filtrosTabela'


export default {
  methods: {
    _normalize: normalize,
    _isEmpty: isEmpty,


    // Gera uma rowFilter a partir da configuração informada (por tabela)
    buildRowFilter(cfg) {
      return makeRowFilter(cfg || {})
    },


    // Gera opções únicas a partir de UMA lista específica (por tabela)
    opcoesUnicasFrom(items, campoOrGetter) {
      const getter = typeof campoOrGetter === 'function' ? campoOrGetter : (r) => r[campoOrGetter]
      return uniqueOptions(items || [], getter)
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/filtrosTabelaMixin.js